import React, { useEffect, useState } from 'react'
import { Container } from '../common/AltCard'
import * as fbq from '../../lib/fbpixel';
import axios from 'axios';
import CommentTab from '../common/CommentTab';
import '../header/header.css'
import LinkBtn, { CTABtnAux, LinkBtnAux } from '../common/LinkBtn';
import { Swiper, SwiperSlide } from "swiper/react";
import 'swiper/css';
import "swiper/css/pagination";
import 'swiper/css/effect-fade';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
// import { Autoplay, Pagination } from 'swiper/modules';
import { Autoplay, Pagination , EffectFade} from "swiper";
import { useAppContext } from '../../utils/Provider';

const NewHero = () => {
  const slideText = [<HeroText1/>, <HeroText2/>, <HeroText4/>]
  const stagingEnpoint = 'https://stagingapi.pakam.ng/api/facebook/notify'

  const handleDownloadAndroid= async() => {
    fbq.event('Download', { device: 'Andriod' })
    
    try {
      const res = await axios.post(stagingEnpoint, {
        headers: {
          'Content-Type': 'application/json'
        }
      });
    } catch (error) {
      console.log(error)
    }
  }

  const handleDownloadIOS= async() => {
    fbq.event('Download', { device: 'IOS' })
    
    try {
      const res = await axios.post(stagingEnpoint, {
        headers: {
          'Content-Type': 'application/json'
        }
      });
    } catch (error) {
      console.log(error)
    }
  }
  
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prevIndex) => (prevIndex + 1) % slideText.length);
    }, 3000);

    return () => clearInterval(interval);
  }, []);


return (
  <div className='bg-[#0D1B1A] relative text-slider h-[100vh]'>
    <TransitionGroup component={null}>
      <CSSTransition
        key={index}
        timeout={1000}
        classNames="fade"
      >
        <div className='absolute w-full h-full'>
          {slideText[index]}
        </div>
      </CSSTransition>
    </TransitionGroup>
  </div>
);
}

export default NewHero


const HeroCTA = ()=>{
  const { value, setValue } = useAppContext();
  const handleReroute = async () => {
    setValue('waste_collector'); // Update the tab state
  };
  return(    
  <>

    <div className='flex space-x-5 md:space-x-10 w-[95%] md:w-[70%] lg:w-[40%]  md:mt-10 ' >
      <CTABtnAux handleClick={handleReroute} style='text-[12px]' link='/contact-us' title='Register as a user'/>
      <LinkBtnAux link='/onboarding' style='text-[12px]' title='Register as a Recycler'/>
    </div>

  </>
  )}    

const HeroText1 = ()=>{
  
  return(    
  <>
      <div style={{
        width:'100%',
        height:'100%',
        backgroundImage:'url(/img/hero1.png)',
        backgroundSize:'cover',
        backgroundPosition:'center'
      }} className=' w-full h-[100vh] pt-[4rem] lg:pt-[7rem] md:h-[80vh] lg:h-[100vh] flex flex-col justify-center items-center gap-12 md:gap-8 top-0'>             

                <h1 className='text-white font-int font-[700] text-[24px] md:text-[48px] lg:text-[60px] text-center leading-[30px] md:leading-[48px] lg:leading-[60px] tracking-[-4%]'>Digitizing Waste. Unlocking<br />finance<span className='font-[700] font-playfair italic'>Powering Circular Africa</span></h1>
                <p className='text-[14px] opacity-80 md:text-[20px] text-center font-[200] w-full text-white md:w-full'>Turn waste into wealth effortlessly</p>

              <HeroCTA/>
               
           </div>

  </>
  )}            
const HeroText2 = ()=>{
  return(    
  <>
      <div style={{
        width:'100%',
        height:'100%',
        backgroundImage:'url(/img/hero2.png)',
        backgroundSize:'cover',
        backgroundPosition:'center'
      }} className=' w-full h-[100vh] pt-[4rem] lg:pt-[7rem] md:h-[80vh] lg:h-[100vh] flex flex-col justify-center items-center gap-12 md:gap-8 top-0'>             

        <h1 className='text-white font-int font-[700] text-[24px] md:text-[48px] lg:text-[60px] text-center leading-[30px] md:leading-[48px] lg:leading-[60px] tracking-[-4%]'>A Smart Way to Power Circular<br /><span className='font-[700] font-playfair italic'>Economy</span></h1>
        <p className='text-[14px] opacity-80 md:text-[20px] text-center font-[200] w-full text-white md:w-full'>Turn waste into wealth effortlessly</p>

              <HeroCTA/>
               
           </div>

  </>
  )}            
const HeroText4 = ()=>{
  return(    
  <>
      <div style={{
        width:'100%',
        height:'100%',
        backgroundImage:'url(/img/hero3.png)',
        backgroundSize:'cover',
        backgroundPosition:'center'
      }} className=' w-full h-[100vh] pt-[4rem] lg:pt-[7rem] md:h-[80vh] lg:h-[100vh] flex flex-col justify-center items-center gap-12 md:gap-8 top-0'>             

          <h1 className='text-white font-int font-[700] text-[24px] md:text-[48px] lg:text-[60px] text-center leading-[30px] md:leading-[48px] lg:leading-[60px] tracking-[-4%]'>Register & Become a Certified<br /><span className='font-[700] font-playfair italic'>Waste Collector</span></h1>
          <p className='text-[14px] opacity-80 md:text-[20px] text-center font-[200] w-full text-white md:w-full'>Turn waste into wealth effortlessly</p>

              <HeroCTA/>
               
           </div>

  </>
  )}            
         
